'use client'

import { useSession } from 'next-auth/react'

import { extractCustomerFromClientSession, extractSupportSessionExpiryFromClientSession } from 'modules/customer'
import { addTestId } from 'shared/utils/tests'

import SupportSessionTimer from './SupportSessionTimer'
import { useSupportSessionExit } from './useSupportSessionExit'

import styles from './SupportSessionBar.module.scss'

const SupportSessionBar = () => {
  const session = useSession()
  const customer = extractCustomerFromClientSession(session)
  const isSupportSession = !!customer?.isSupportSession
  // Absent for sessions started before the countdown existed — those keep
  // running without one rather than being cut short mid-work.
  const expiresAt = extractSupportSessionExpiryFromClientSession(session)

  const handleExit = useSupportSessionExit()

  if (!isSupportSession) {
    return null
  }

  return (
    <div
      data-support-session-bar
      className={styles.bar}
      role='alert'
      {...addTestId('support-session-bar')}
    >
      <div className={styles.timerWrapper}>
        <span aria-hidden='true' className={styles.supportSessionMarker} />
        {expiresAt && <SupportSessionTimer expiresAt={expiresAt} />}
      </div>
      <p className={styles.message} {...addTestId('support-session-bar-message')}>
        Działasz jako: <span className={styles.email}>{customer?.email}</span>.
        Zmiany zapisują się na tym koncie.
      </p>
      <button
        type='button'
        className={styles.exitButton}
        onClick={handleExit}
        {...addTestId('support-session-bar-exit-button')}
      >
        <span className={styles.exitLabel}>Zakończ sesję wsparcia</span>
        <span className={styles.exitLabelShort}>Zakończ</span>
      </button>
    </div>
  )
}

export default SupportSessionBar
